import * as i from 'types';
import { StylesConfig, GroupBase } from 'react-select';

const selectDropdownStyles = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(theme: i.Theme): StylesConfig<Option, IsMulti, Group> => ({
  container: (provided) => ({
    ...provided,
    width: '100%',
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: 48,
    border: state.menuIsOpen
      ? `1px solid ${theme.colors.primary}`
      : `1px solid ${theme.colors.gray.border}`,
    backgroundColor: theme.colors.white,
    fontSize: 16,
    boxShadow: 'none',
    cursor: 'pointer',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    fill: theme.colors.gray.border,
    height: 20,
    width: 20,
    padding: 0,
    marginRight: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '100%',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    fill: theme.colors.black,
    marginRight: 20,
    width: 20,
    height: 46,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0 2px',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: theme.colors.gray.neutral,
  }),
  menu: (provided) => ({
    ...provided,
    marginTop: 8,
    padding: 8,
    borderRadius: 4,
    border: `1px solid ${theme.colors.gray.neutral}`,
    backgroundColor: `${theme.colors.white}`,
    boxShadow: 'none',
    boxSizing: 'border-box',
  }),
  multiValue: (provided) => ({
    ...provided,
    margin: '0 2px',
    height: 32,
    backgroundColor: theme.colors.primary,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    padding: 0,
    paddingLeft: 0,
    maxWidth: 98,
    margin: '0 8px',
    color: theme.colors.white,
    textOverflow: 'ellipsis',
    textTransform: 'uppercase',
    fontWeight: 500,
    fontSize: 12,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    fill: theme.colors.white,
    color: theme.colors.white,
    height: 16,
    width: 16,
    margin: '0 4px',
    padding: 0,
    '&:hover': {
      backgroundColor: theme.colors.white,
      fill: theme.colors.gray.border,
      color: theme.colors.black,
    },
    flexShrink: 0,
    cursor: 'pointer',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: theme.colors.black,
  }),
  option: (provided, state) => ({
    ...provided,
    minHeight: 32,
    borderRadius: '4px',
    color: state.isFocused
      ? `${theme.colors.white}`
      : `${theme.colors.black}`,
    backgroundColor: state.isFocused
      ? `${theme.colors.primary}`
      : 'transparent',
    '&:hover': {
      backgroundColor: theme.colors.primary,
      color: theme.colors.white,
    },
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  }),
});

export default selectDropdownStyles;
